module.exports = __webpack_public_path__ + "img/banner8.3670764e.png";